const colors = {
    primary: {
        main: "#23354d",
        dark: "#232c38",
        light: "#1478fc"
    },
    secondary: {
        main: "#ff8800",
        dark: "#ff5500",
        light: "#ffaa00",
    },
    tertiary: {
        main: "#00b3ff",
        dark: "#196bc2",
        light: "#87ebff",
    },
    red: {
        main: "#d60000",
        dark: "#800a0a",
        light: "#ffadad",
    },
    green: {
        main: "#00db1a",
        dark: "#10731f",
        light: "#73ff88",
    },
    text: {
        main: "#000000",
        light: "#ffffff",
    },
    choice: {
        normal: {
            main: "#000000",
            dark: "#000000",
            light: "#222222",
        },
        selected: {
            main: "#555555",
            dark: "#222222",
            light: "#999999"
        },
    },
    answer: {
        default: "rgba(0,0,0,0)",
        correct: "#a3ffa8",
        wrong: "#ffb5b5",
    }
};

export default colors;